import Startup from './Startup';
import EachDepartment from './EachDepartment';
import GrowFaster from './GrowFaster';
import KeyHighlights from './KeyHighlights';
import AiExpertDirectBenifits from './AiExpertDirectBenifits';
import LandingPageComponentWrapper from '../components/LandingPageComponentWrapper';
import EndingSection from '../AvatarDigitalMarketer/EndingSection';
import Text from '../components/Text';
import { FAQSection } from '../AvatarDigitalMarketer/FAQSection';
import Input from '../components/Input';
import Button from '../components/Button';
import { useState } from 'react';
import CardsCarousel from '../components/card-carousel';
import StickyHeader from '../components/StickyHeader';

const faqItemsForStartups = [
  {
    id: 1,
    question: "What is AI For Startups?",
    answer:
      "It’s a complete system that runs your school — from marketing and teaching to fee collection and legal work. You get full-time AI employees who work automatically for your school.",
  },
  {
    id: 2,
    question: "How will it help me start or grow my school?",
    answer:
      "It handles everything: Marketing and admissions (AI Marketing Team), Teaching and motivation (AI Teaching Team), Fees, communication, and parent reports (AI Operations Team), and Issue solving and support (AI Support Team). Everything works together to save money, save time, and grow your school faster.",
  },
  {
    id: 3,
    question: "I’m not a technical person — can I still use it?",
    answer:
      "Yes! You don’t need any computer skills. It is completely automated. Upload your logo and photos — your school’s AI system goes live in under 10 minutes.",
  },
  {
    id: 4,
    question: "How does it help in marketing?",
    answer:
      "Your AI Marketing Team builds your website, runs social media, creates reels, and manages admissions automatically. You also get all print materials — brochures, banners, and leaflets — ready to use.",
  },
  {
    id: 5,
    question: "Can it help me with accounts and legal setup?",
    answer:
      "Yes! The AI Startup Suite gives you CS, CA, and legal support — for company registration, accounts, and permissions. Everything is organised and guided by experts.",
  },
  {
    id: 6,
    question: "How much does it cost to start?",
    answer:
      "You get ₹5 lakh worth of AI services free. We are onboarding only 0.1% schools per state — early members get lifetime benefits.",
  },
  {
    id: 7,
    question: "When will I see results?",
    answer:
      "Within a few days of setup — your website goes live, marketing starts, and parents begin engaging instantly.",
  },
  {
    id: 8,
    question: "Can this system double my admissions?",
    answer:
      "Yes! AI helps you reach more parents, reply faster, and convert leads easily — many schools have already doubled their admissions using SooMuch.ai.",
  },
  {
    id: 9,
    question: "What makes SooMuch.ai different?",
    answer:
      "Other software just gives you tools. SooMuch.ai gives you AI Employees who actually work for you: a Marketing Manager who runs your campaigns, a Teaching Coach who inspires students, an Operations Officer who manages daily work, and a Support Executive who keeps everything running. It’s not just software — it’s your full AI team.",
  },
  {
    id: 10,
    question: "How can I see it in action?",
    answer:
      "Join our free live webinar and see your school come alive with AI in real time. Setup takes less than 10 minutes. Only 0.1% of schools per state can join!",
  },
];


const componentsList = [
  { component: <Startup />, bgColor: "bg-[#ECECF7]", id: "startup-Startup" },
  { component: <EachDepartment />, bgColor: "", id: "startup-EachDepartment" },
  { component: <GrowFaster />, bgColor: "bg-[#ECECF7]", id: "startup-GrowFaster" },
  { component: <KeyHighlights />, bgColor: "", id: "startup-KeyHighlights" },
  { component: <AiExpertDirectBenifits />, bgColor: "bg-[#ECECF7]", id: "startup-AiExpertDirectBenifits" },
  {
    component: (
      <EndingSection
        badge={"READY TO LAUNCH?"}
        title={"Start strong, grow fast, and stay ahead forever."}
        desc={"Your teachers feel lighter. Your parents feel closer. Your classrooms feel calmer. Your school finally runs the way it was always meant to."}
        grdBtn={"Activate AI for Startups"}
        outBtn={"Join Live Demo"}
        avatar={"/images/new-landing-page/startupPersonV2.png"}
        avatarBoxClass={"-right-20"}
        avatarClassName={"max-w-sm"}
        customFrame={
          <div className="grid grid-cols-2 md:grid-cols-1 items-center bg-[#4949DE] rounded-3xl py-12 px-20 md:px-4 md:gap-8">
            <div className="space-y-4 mr-44 md:mr-0">
              <h2 className="text-[white] text-2xl max-w-xs font-semibold" style={{ fontFamily: 'Instrument Sans, sans-serif' }}>
                What are your requirements as a school startup?
              </h2>
              <CheckboxList />
            </div>
            <div className="space-y-10 bg-[white] rounded-3xl shadow-2xl p-8 ml-20 md:ml-0">
              <div className="space-y-4">
                <Input label="School Name" />
                <Input label="Full Name" />
                <Input label="Email/Phone" />
              </div>
              <div>
                <Button label="Get My School Startup Plan" type="gradient" cName="w-full" />
              </div>
            </div>
          </div>
        }
      />
    ),
    bgColor: "",
    id: "startup-EndingSection"
  },
  { component: <FAQSection faqItems={faqItemsForStartups} />, bgColor: "", id: "startup-FAQSection", isFlex1: true },
]

const AvatarStartup = () => {
  return <>
    <div className="bg-[#FCFAFF] mt-40" style={{
      position: "relative",
      zIndex: 1,
      // backgroundColor: "transparent",
    }}>
      {componentsList.map((element: any, index) => (
        <div
          key={"components" + index}
          id={element?.id}
        // ref={(el) => (sectionRefs.current[index] = el) as any}
        >
          <LandingPageComponentWrapper bg={element?.bgColor} isFlex1={element?.isFlex1}>
            {element?.component}
          </LandingPageComponentWrapper>
        </div>))}
    </div>
  </>
}

export default AvatarStartup;


export function CheckboxList() {
  const [checkedItems, setCheckedItems] = useState({
    marketing: false,
    cs: false,
    ca: false,
    legal: false
  });

  const handleChange = (key) => {
    setCheckedItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const items = [
    { key: 'marketing', label: 'Complete Soomuch.ai Marketing Suite' },
    { key: 'cs', label: 'Complete CS Assistance' },
    { key: 'ca', label: 'Complete CA Assistance' },
    { key: 'legal', label: 'Complete Legal Assistance' }
  ];

  return <div className='flex flex-col gap-2'>
    <Text label={"Select from the options below:"} cName='text-sm text-[white] sm:text-xs sm:leading-5' />
    {items.map(item => (
      <label key={item.key} className="flex items-center gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={checkedItems[item.key]}
          onChange={() => handleChange(item.key)}
          className="w-4 h-4 cursor-pointer appearance-none border-2 border-[white] bg-transparent checked:border-[white] rounded-sm"
        />
        <span className="text-[white] text-sm font-normal">
          {item.label}
        </span>
      </label>
    ))}
  </div>
}